export default __webpack_public_path__ + "static/media/13.843280d1.png";